import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';
import {
  Reference,
  TaskInput,
} from 'src/careflow/ph-core/fhir-client/resources';
import { getTableRowDueTo } from 'src/careflow/common/common-utils';
import { getReferenceResourceId } from 'src/careflow/helpers/common';

export const TaskWrapper = createWrapper('Task', (task) => ({
  getPastDue(): string {
    const parentExtension = task?.extension?.find(
      (ext) => ext?.url === 'https://terminology.patientholistics.app/fhir/StructureDefinition/ph-task-detail'
    );
    const nestedRequestedPeriod = parentExtension?.extension?.find(
      (ext) => ext?.url === 'requestedPeriod'
    );
    const dueDate = nestedRequestedPeriod?.valuePeriod?.end;
    const result = getTableRowDueTo(
      new Date(task?.executionPeriod?.end || ''),
      task?.status
    ).subStatus;
    return result;
  },
  getInternalNumber: (TASK_INTERNAL_NUMBER_IDENTIFIER_SYSTEM: string): string | null =>
    task?.identifier?.find?.(({ system }) => system === TASK_INTERNAL_NUMBER_IDENTIFIER_SYSTEM)
      ?.value ?? null,
  getDueDate: (): string | undefined => {
    const parentExtension = task?.extension?.find(
      (ext) => ext?.url === 'https://terminology.patientholistics.app/fhir/StructureDefinition/ph-task-detail'
    );
    const nestedRequestedPeriod = parentExtension?.extension?.find(
      (ext) => ext?.url === 'requestedPeriod'
    );
    const dueDate = nestedRequestedPeriod?.valuePeriod?.end;

    if (!dueDate) {
      return;
    }

    const date = new Date(dueDate);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  },
  getTaskType: (): string | undefined => task?.code?.coding?.[0]?.code,
  getTaskTypeDisplay: (): string | undefined => task?.code?.coding?.[0]?.display,
  getReasonCode: (): string | undefined => task?.reasonCode?.coding?.[0]?.code,
  getReasonDisplay: (): string | undefined => task?.reasonCode?.coding?.[0]?.display,
  getForDisplay: (): string | undefined => task?.for?.display,
  getComments: (): string | undefined => task?.note?.[0]?.text,
  getEndDate: (): string | undefined => task?.executionPeriod?.end,
  getStartDate: (): string | undefined => task?.executionPeriod?.start,
  getBasedOn: (): Reference[] | undefined => task?.basedOn,
  getOwnerId: (): string | undefined => task?.owner?.reference,
  getOwnerDisplay: () => task?.owner?.display,
  getPatientId: (): string | undefined => {
    if (!task?.for?.reference?.includes('Patient')) return;
    return getReferenceResourceId(task?.for?.reference);
  },
  getTaskNumberNAT: (taskNATIdenitifierType: string): string | undefined =>
    task?.identifier?.find((identifier) => identifier?.type?.text === taskNATIdenitifierType)
      ?.value,
  getURLResources: (): TaskInput[] =>
    task?.input?.filter?.(({ type }) =>
      type?.coding?.some?.(({ code }) => code?.toLowerCase?.()?.includes?.('resource.url'))
    ) ?? [],
  isActive: (): boolean => {
    return [
      'draft',
      'requested',
      'received',
      'accepted',
      'ready',
      'in-progress',
      'on-hold',
    ].includes(task.status);
  },
}));
export type WrappedTask = ReturnType<typeof TaskWrapper>;
